import "./ServicePostingReview.css";
import { Card, CardHeader, CardTitle, CardContent } from "./beui/SurfaceCard";
import { PostingReview, type PostingReviewField } from "./PostingReview";

const GROUPS = [
  { title: "Service details", ids: ["title", "category", "location", "description", "tags"] },
  { title: "Scope of work", ids: ["previousWork", "whatsIncluded", "requirements"] },
  { title: "Pricing", ids: ["amount"] },
  { title: "Photos", ids: ["photos", "previousPhotos"] },
];

export function ServicePostingReview({ fields, disabled }: { fields: PostingReviewField[]; disabled: boolean }) {
  return <div className="service-posting-review mt-4 space-y-4">{GROUPS.map(({ title, ids }) => {
    const grouped = fields.filter(field => ids.includes(field.id));
    if (!grouped.length) return null;
    return <Card key={title} size="compact" className={title === "Pricing" ? "service-review-pricing" : undefined}>
      {title !== "Pricing" && <CardHeader><CardTitle as="h4">{title}</CardTitle></CardHeader>}
      <CardContent><PostingReview fields={grouped} disabled={disabled} /></CardContent>
    </Card>;
  })}</div>;
}
